import { Dialog, type DialogProps } from "@verde/compose-ui";
import {
  dashboardQueryKeys,
  fundOperationQueryKeys,
  useUpdateFundOperation,
} from "@verde/entities";
import { dayjs, queryClient } from "@verde/utils";

interface OperationFinishedDialogParams
  extends Pick<DialogProps, "open" | "onClose"> {
  operationId?: number;
}

export default function OperationFinishedDialog({
  open,
  onClose,
  operationId,
}: OperationFinishedDialogParams) {
  const update = useUpdateFundOperation(operationId);

  if (!operationId) return null;

  return (
    <Dialog
      open={open}
      size="sm"
      header={{
        title: "Deseja concluir?",
        size: "lg",
        kind: "warning",
      }}
      footer={{
        secondary: { children: "Fechar", onClick: () => onClose?.() },
        primary: {
          children: "Finalizar",
          onClick: async () => {
            await update.mutateAsync({
              completed_at: dayjs().toISOString(),
            });

            queryClient.invalidateQueries(fundOperationQueryKeys.list({}));
            queryClient.invalidateQueries(dashboardQueryKeys.fund.count());

            onClose?.();
          },
          loading: update.isLoading,
        },
      }}
      onClose={() => onClose?.()}
    >
      <p>
        Deseja concluir a etapa de monitoramento para a operação #{operationId}?
      </p>
    </Dialog>
  );
}
